import { CertificateRepository } from "../../../domain/repositories/certificate.repository";
import { GetDocumentsSystemGeneratesUseCase } from "../../../domain/usecases/certificate/get-documents-system-generates.usecase";
import { InsertDocumentSystemGenerateUseCase } from "../../../domain/usecases/certificate/insert-document-system-generate.usecase";
import { UpdateDocumentSystemGenerateUseCase } from "../../../domain/usecases/certificate/update-document-system-generate.usecase";



const getDocumentsSystemGeneratesUseCaseFactory = (certificate: CertificateRepository) =>
new GetDocumentsSystemGeneratesUseCase( certificate);
export const GetDocumentsSystemGeneratesUseCaseProvider = {
    provide: GetDocumentsSystemGeneratesUseCase,
    useFactory: getDocumentsSystemGeneratesUseCaseFactory,
    deps: [ CertificateRepository],
};


const insertDocumentSystemGenerateUseCaseFactory = (certificate: CertificateRepository) => new InsertDocumentSystemGenerateUseCase( certificate );
export const InsertDocumentSystemGenerateUseCaseProvider = {
    provide: InsertDocumentSystemGenerateUseCase,
    useFactory:insertDocumentSystemGenerateUseCaseFactory,
    deps: [ CertificateRepository ],
};

const updatedocumentsystemgenerateUseCaseFactory =
(ClientRepo: CertificateRepository) =>
new UpdateDocumentSystemGenerateUseCase(
    ClientRepo
);

export const
UpdateDocumentSystemGenerateUseCaseProvider = {
    provide:
    UpdateDocumentSystemGenerateUseCase,
    useFactory:
    updatedocumentsystemgenerateUseCaseFactory,
    deps: [
        CertificateRepository
    ],
};
